import { faCheck, faCopy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import { WhiteBackgroundModal } from '../../shared/modal/whitePopUp/WhiteBackgroundModal';

export function SharePopUp({ setShareOpen }) {
  const { t } = useTranslation();
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopiedToClipboard(true);
  };

  return (
    <WhiteBackgroundModal
      hasCloseIcon
      title={{ text: t('M006'), showTitle: true }}
      handleClose={() => setShareOpen(false)}
      size="small"
      dialogTitle={t('modal.share.info')}
    >
      <div className="share-container">
        <div className="share-body">
          <div className="title">{t('M006W')}</div>
          <div className={copiedToClipboard ? 'copied visible' : 'copied'}>
            <span role="alert" aria-live="polite">
              {t('M072W')}
            </span>
            <FontAwesomeIcon icon={faCheck} className="icon" />
          </div>
          <div className="url">
            <div className="url-address">{window.location.href}</div>
            <Button
              variant="ghost"
              color="dark"
              onClick={handleCopyToClipboard}
              icon={{ faIconDefinition: faCopy, size: 'xl', color: 'white' }}
              iconPosition="right"
            >
              <span className="visuallyHidden">{t('M106')}</span>
            </Button>
          </div>
        </div>
      </div>
    </WhiteBackgroundModal>
  );
}
